/**
 * Configuration utility for API and WebSocket URLs
 * Handles both local development and production environments
 */

/**
 * Get the backend API base URL
 * Priority:
 * 1. REACT_APP_BACKEND_URL (explicit)
 * 2. Derived from window.location (browser-based)
 * 3. Fallback to localhost for development
 */
export const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  // Browser-based detection (for production builds)
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol;
    const host = window.location.host;
    // Remove port if present (for production)
    const hostname = host.split(':')[0];
    // Use same protocol and host as frontend
    return `${protocol}//${hostname}:8001`;
  }

  // Fallback for development
  return 'http://localhost:8001';
};

/**
 * Get the API endpoint URL
 * @param {string} path - API path (e.g., '/auth/login')
 * @returns {string} Complete API URL
 */
export const getApiUrl = (path) => {
  const baseUrl = getBackendUrl().replace(/\/+$/, ''); // Remove trailing slashes
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}/api${normalizedPath}`;
};

